import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/programmes/page.tsx");
